import css from 'styled-jsx/css';

export default css`
  .features-block-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .features-block-icon-active {
    transition: all 0.4s ease-in-out;
    transform: rotate(90deg);
  }
  .featured-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .featured-title {
    width: 100%;
    text-align: center;
    font-family: 'Roboto-Medium';
    font-size: 20px;
    font-weight: 600;
  }
  @media (max-width: 425px) {
    .featured-title {
      padding-left: 50px;
      text-align: left;
      font-size: 16px;
      font-weight: 600;
    }
  }
  @media (max-width: 767px) {
    .featured-title {
      text-align: left;
      font-size: 16px;
      font-weight: 600;
    }
  }
  @media (min-width: 426px) {
    .featured-title {
      text-align: center;
    }
  }
  @media (max-width: 425px) {
    .featured-title {
      padding-left: 50px;
    }
  }
  @media (max-width: 375px) {
    .featured-title {
      padding-left: 32px;
    }
  }
  @media (max-width: 320px) {
    .featured-title {
      padding-left: 5px;
    }
  }
  .features-wrapper {
    max-width: 1230px;
    display: grid;
    gap: 20px;
    width: 100%;
    justify-items: center;
    align-content: center;
    padding: 20px 35px;
    margin-bottom: 30px;
  }
  @media (max-width: 1216px) {
    .features-wrapper {
      max-width: 865px;
      padding: 20px 0;
    }
  }
  @media (max-width: 921px) {
    .features-wrapper {
      max-width: 643px;
    }
  }
  @media (min-width: 768px) {
    .features-wrapper {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (max-width: 767px) {
    .features-wrapper {
      max-width: 329px;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  @media (max-width: 375px) {
    .features-wrapper {
      max-width: 310px;
    }
  }
  .feature-container {
    width: 100%;
  }
  .features-block {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #141414;
    border-radius: 5px;
    padding: 25px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: border 0.3s ease-in-out;
  }
  .features-block:hover {
    border: 1px solid #a50000;
  }
  .features-block-title {
    width: 100%;
    text-align: center;
    font-family: 'Roboto-Normal', sans-serif;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .posts-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition:
      max-height 0.4s ease-in-out,
      opacity 0.4s ease-in-out;
  }
  .posts-list.active {
    opacity: 1;
    max-height: 1000px;
  }
  .post-card {
    padding: 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #242424;
  }
`;
